import { buildSearchParams, urlBuilder } from '@starjack/utils';
import { baseApi } from '@starjack/api';
import {
    convertIssuedVoucherToFrontend,
    GetIssuedVouchersParams,
    GetIssuedVouchersResponse,
    IssueVoucherTemplateDTO,
    IssueVouchersCommand,
    IssuedVoucherBackendDTO,
    IssueVouchersResponseDTO,
} from '../model/issuedVoucher.types';

export const issuedVoucherUrls = {
    issuedVouchers: urlBuilder('order', '/admin/issued-vouchers'),
    templates: urlBuilder('order', '/admin/issued-vouchers/templates'),
    pdf: (id: string) =>
        `${urlBuilder('order', '/admin/issued-vouchers')}/${id}.pdf`,
    preview: (templateId: string) =>
        `${urlBuilder('order', '/vouchers')}/${templateId}/preview`,
};

export const issuedVoucherApi = baseApi
    .enhanceEndpoints({ addTagTypes: ['ISSUED_VOUCHERS'] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getIssueVoucherTemplates: builder.query<
                IssueVoucherTemplateDTO[],
                void
            >({
                query: () => issuedVoucherUrls.templates,
                providesTags: ['ISSUED_VOUCHERS'],
            }),

            getIssuedVouchers: builder.query<
                GetIssuedVouchersResponse,
                GetIssuedVouchersParams
            >({
                query: (params) =>
                    `${issuedVoucherUrls.issuedVouchers}${buildSearchParams({
                        code: params.code || undefined,
                        page: params.page,
                        size: params.size,
                    })}`,
                transformResponse: (
                    response: Omit<GetIssuedVouchersResponse, 'content'> & {
                        content: IssuedVoucherBackendDTO[];
                    }
                ): GetIssuedVouchersResponse => ({
                    ...response,
                    content: (response?.content ?? []).map(
                        convertIssuedVoucherToFrontend
                    ),
                }),
                providesTags: ['ISSUED_VOUCHERS'],
            }),

            issueVouchers: builder.mutation<
                IssueVouchersResponseDTO,
                IssueVouchersCommand
            >({
                query: (body) => ({
                    url: issuedVoucherUrls.issuedVouchers,
                    method: 'POST',
                    body,
                }),
                transformResponse: (response: {
                    vouchers?: IssuedVoucherBackendDTO[];
                }): IssueVouchersResponseDTO => ({
                    vouchers: (response?.vouchers ?? []).map(
                        convertIssuedVoucherToFrontend
                    ),
                }),
                invalidatesTags: ['ISSUED_VOUCHERS'],
            }),
        }),
    });

export const {
    useGetIssueVoucherTemplatesQuery,
    useGetIssuedVouchersQuery,
    useIssueVouchersMutation,
} = issuedVoucherApi;
